// extracted by mini-css-extract-plugin
export var header = "header-module--header--9422c";
export var headerDark = "header-module--headerDark--9e776";
export var headerProject = "header-module--headerProject--c87f9";
export var logo = "header-module--logo--3c90d";
export var menu = "header-module--menu--cb294";
export var messengers = "header-module--messengers--e09de";
export var open = "header-module--open--2afb8";
export var scrolled = "header-module--scrolled--ace10";
export var staticImg = "header-module--staticImg--69017";